import { FlatItem } from 'src/types/elements.type';
import { http } from '@martech-solution/utils/utils';

const controller = 'hr/additional-types';

export const getAdditionalTypesDropdown = async () => {
  return http.get<FlatItem[]>(`${controller}/dropdown`);
};
